<template>
    <div :class="prefixCls">
        <div :class="`${prefixCls}-trigger`" 
            ref="countryCodeTrigger" 
            v-clickoutside="handleClose"
            @click="handleClick">
            <slot></slot>
        </div>
        <ul :class="`${prefixCls}-content`"
            :style="{ top: top }"
            v-if="isDisplayCountryCode">
            <li v-for="(code, country) in codes" 
                @click="handleOnSelect({
                    country: country,
                    code: code,
                    value: t(`country.${country}`)
                }, true)"
                :key="country">
                <span :class="`${prefixCls}-country`">
                    {{t(`country.${country}`)}}
                </span>
                <span :class="`${prefixCls}-code`">
                    {{code}}
                </span>
            </li>
        </ul>
    </div>
</template>
<script>
    import Locale from '../../../mixins/locale'
    import code from './code'
    import clickoutside from '../../../directives/clickoutside'

    const prefixCls = 'yy-country-code-web'
    export default {
        name: 'countryCodeWeb',
        props: {
            onSelect: {
                type: Function,
                default: function(opt) {
                    return false
                }
            },
        },
        directives: {
            clickoutside
        },
        data() {
            return {
                prefixCls: prefixCls,
                codes: code,
                isDisplayCountryCode: false,
                top: 0
            }
        },
        mixins: [Locale],
        methods: {
            handleOnSelect(opt, isEmit) {
                this.handleClose()
                if(isEmit) {
                    this.onSelect(opt)
                }
            },
            handleClick() {
                this.isDisplayCountryCode = !this.isDisplayCountryCode
            },
            handleClose() {
                this.isDisplayCountryCode = false
            }
        },
        mounted () {
            this.top = this.$refs.countryCodeTrigger.offsetHeight + 'px'
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/business/country-code/country-code-w.vue